import { Injectable } from '@angular/core';
import { HttpRequestService } from '../../shared/services/http-request.service';
import { accountSupervisorStartEndDateDTO, asOrderCountsAndOutstandingEstimates, asPlatinumReportsViewModel, calendarASAMBaseViewModel, calendarASAMDataDTO } from '../models/account-supervisor.model';
import { Observable } from 'rxjs';
import { ApiUrlConstants } from '../../shared/constants/api_url_constants';

@Injectable({
  providedIn: 'root'
})
export class AccountSupervisorService {

  constructor(private httpRequestService: HttpRequestService) { }

  getOrderCountAndOutstandingEstimates(data:accountSupervisorStartEndDateDTO): Observable<asOrderCountsAndOutstandingEstimates[]> {
    return this.httpRequestService.postData<asOrderCountsAndOutstandingEstimates[]>(ApiUrlConstants.asOrderCountAndOutstandingEstimatesGet, data);
  }
  getASPlatinumReportCount(data:accountSupervisorStartEndDateDTO): Observable<asPlatinumReportsViewModel[]> {
    return this.httpRequestService.postData<asPlatinumReportsViewModel[]>(ApiUrlConstants.asPlatinumReportCountGet, data);
  }
  getCalendarDataForASAM(data:calendarASAMDataDTO): Observable<calendarASAMBaseViewModel> {
    return this.httpRequestService.postData<calendarASAMBaseViewModel>(ApiUrlConstants.asAMCalendarData, data);
  }
}
